<template>
  <div class="Background">
    <div class="Background_wrapper"></div>
  </div>
</template>

<script>
  import mouseParallax from '@/mixins/mouseParallax'

  export default {
    mixins: [ mouseParallax ],
    data() {
      return {
       
      }
    },
    mounted()
    {
      if(this.$tools.isMobile())
        this.destroyParallax()
    }
  }
</script>

<style lang="stylus" scoped>
.Background

  position fixed
  top -10%
  left -10%
  width 120%
  height 120%
  overflow hidden
  will-change transform

  &_wrapper

    width 200%
    height 400%
    background-image url('/assets/images/pattern-pictos.png')
    background-position center center
    background-size 360px
    background-repeat repeat
    opacity 0.3
    background-color white
</style>